import { render, staticRenderFns } from "./Veiculos.vue?vue&type=template&id=1c87f32f&scoped=true&"
import script from "./Veiculos.vue?vue&type=script&lang=js&"
export * from "./Veiculos.vue?vue&type=script&lang=js&"
import style0 from "./Veiculos.vue?vue&type=style&index=0&id=1c87f32f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87f32f",
  null
  
)

export default component.exports